import { render, staticRenderFns } from "./repairpopup.vue?vue&type=template&id=2b718f32"
import script from "./repairpopup.vue?vue&type=script&lang=js"
export * from "./repairpopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports